import React from "react";
import { useSearchParams } from "react-router-dom";
import {
  currentUtcMonth,
  formatMonthLong,
  trailingMonths,
} from "../utils/months";

/** Trailing 12-month dropdown; writes to ?month=YYYY-MM. */
export function MonthPicker() {
  const [searchParams, setSearchParams] = useSearchParams();
  const months = trailingMonths(12);
  const fallback = currentUtcMonth();
  const selected = searchParams.get("month") || fallback;

  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    const next = new URLSearchParams(searchParams);
    if (value === fallback) {
      // Default — keep the URL clean.
      next.delete("month");
    } else {
      next.set("month", value);
    }
    setSearchParams(next);
  };

  return (
    <select
      value={selected}
      onChange={onChange}
      className="flex h-8 rounded-md border border-input bg-card px-3 text-sm text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      aria-label="Select month"
    >
      {months.map((m) => (
        <option key={m} value={m}>
          {formatMonthLong(m)}
        </option>
      ))}
    </select>
  );
}
